import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// IDX Broker widget scripts define custom elements; guard against duplicate
// registration when widgets remount (React StrictMode / SPA navigation).
const originalDefine = window.customElements.define.bind(window.customElements);
window.customElements.define = (name, ctor, options) => {
  if (window.customElements.get(name)) return;
  originalDefine(name, ctor, options);
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
